var _defs, _g, _polygon, _polygon2, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _polygon3, _polygon4, _polygon5, _path5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _g2, _polygon13, _polygon14, _polygon15, _polygon16, _path6, _path7, _polygon17, _polygon18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKmsLogoOneline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 759.67 32.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#929292;}.cls-4{fill:#646363;}.cls-5{fill:#24bbe7;}.cls-6{fill:#59bba8;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 759.67,
    height: 32.28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.55,10.81c0-6.31-3.39-9-10.4-9H73.89V30.45h4.45V5.65h6.81c3.94,0,5.82,1.69,5.82,5.24,0,3.3-1.47,5.49-5.78,5.49H81l-1.13,3.79h5.91l5.07,10.28h4.91L90.14,19.1c3.67-1.32,5.41-3.92,5.41-8.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M655.39,10.81c0-6.31-3.4-9-10.41-9H633.73V30.45h4.44V5.65H645c3.94,0,5.82,1.69,5.82,5.24,0,3.3-1.46,5.49-5.77,5.49H640.8l-1.14,3.79h5.92l5.07,10.28h4.9L650,19.1c3.66-1.32,5.41-3.92,5.41-8.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M499.35,10.81c0-6.31-3.4-9-10.41-9H477.69V30.45h4.44V5.65h6.81c3.94,0,5.82,1.69,5.82,5.24,0,3.3-1.46,5.49-5.77,5.49h-4.23l-1.14,3.79h5.92l5.07,10.28h4.9L493.94,19.1c3.66-1.32,5.41-3.92,5.41-8.29"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "146.99 5.65 155.02 5.65 155.02 30.45 159.51 30.45 159.51 5.65 167.44 5.65 167.44 1.86 146.99 1.86 146.99 5.65"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "427.23 5.65 435.25 5.65 435.25 30.45 439.74 30.45 439.74 5.65 447.68 5.65 447.68 1.86 427.23 1.86 427.23 5.65"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 171.1,
    y: 1.86,
    width: 4.45,
    height: 28.59
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 505.22,
    y: 1.86,
    width: 4.45,
    height: 28.59
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 686.17,
    y: 1.86,
    width: 4.45,
    height: 28.59
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M203.43,5.69V1.86H181.51V5.65H198L179.82,26.5v3.95h2.06Zm.23,24.76V26.66H188.73l-3.3,3.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.68,5.65H137l4,14.56H130.58ZM123.2,30.48h4.45l2-6.43H142l2.06,6.39h4.49L140.48,1.86h-9.12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M391.64,5.65H394l4,14.56H387.54ZM380.16,30.48h4.44l2-6.43H399L401,30.44h4.49L397.43,1.86h-9.12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M286.64,5.64H289l4,14.56H282.54ZM275.16,30.46h4.44l2-6.43H294L296,30.42h4.49L292.43,1.84h-9.12Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "121.16 26.66 105.9 26.66 105.9 5.65 119.93 5.65 119.93 1.86 101.41 1.86 101.41 30.45 121.16 30.45 121.16 26.66"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "227.06 26.66 211.81 26.66 211.81 5.65 225.83 5.65 225.83 1.86 207.31 1.86 207.31 30.45 227.06 30.45 227.06 26.66"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "629.1 26.66 613.84 26.66 613.84 5.65 627.87 5.65 627.87 1.86 609.35 1.86 609.35 30.45 629.1 30.45 629.1 26.66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.59,30.45h5.19L59.51,15.74,69,1.86H64L54.55,15.74Zm-16,0h4.45V1.86H48.64Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "108.5 13.84 107.41 17.64 116.78 17.64 117.9 13.84 108.5 13.84"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "367.84 5.65 381.87 5.65 381.87 1.86 363.35 1.86 363.35 30.45 367.85 30.45 367.84 5.65"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "370.44 13.84 369.35 17.64 378.73 17.64 379.84 13.84 370.44 13.84"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "214.4 13.84 213.31 17.64 222.69 17.64 223.8 13.84 214.4 13.84"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "737.81 26.66 722.55 26.66 722.55 5.65 736.58 5.65 736.58 1.86 718.06 1.86 718.06 30.45 737.81 30.45 737.81 26.66"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "725.15 13.84 724.06 17.64 733.43 17.64 734.55 13.84 725.15 13.84"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "616.44 13.84 615.35 17.64 624.73 17.64 625.84 13.84 616.44 13.84"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M603.49,2.42a63.51,63.51,0,0,0-9.07-1c-5.72,0-9.52,2.38-9.52,8.14,0,5,2.67,6.86,8.86,8.44,4.38,1.05,5.68,1.88,5.68,4.3,0,3-1.63,4.6-5.18,4.6-3,0-8.61-.75-8.61-.75l-.46,3.71A60.82,60.82,0,0,0,594.55,31c5.64,0,9.56-2.71,9.56-9,0-4.88-2.17-6.47-8.18-8.14-4.89-1.34-6.39-2-6.39-4.64,0-2.46,1.79-3.72,5.3-3.72,2.42,0,8.27.67,8.27.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M759,2.42a63.5,63.5,0,0,0-9.06-1c-5.72,0-9.52,2.38-9.52,8.14,0,5,2.67,6.86,8.85,8.44,4.39,1.05,5.68,1.88,5.68,4.3,0,3-1.63,4.6-5.18,4.6-3,0-8.6-.75-8.6-.75l-.46,3.71A60.81,60.81,0,0,0,750.1,31c5.64,0,9.57-2.71,9.57-9,0-4.88-2.17-6.47-8.19-8.14-4.88-1.34-6.39-2-6.39-4.64,0-2.46,1.8-3.72,5.31-3.72,2.42,0,8.27.67,8.27.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M563.17,19.58v7a27.21,27.21,0,0,1-4.56.38c-5.85,0-7.06-2.93-7.06-10.7,0-8.07,1.46-10.66,7.19-10.66a82.51,82.51,0,0,1,8.86.67l.17-3.68A56.42,56.42,0,0,0,558,1.44c-8.53,0-11.29,4.77-11.29,14.8,0,9.49,2.34,14.75,11.45,14.75a75.23,75.23,0,0,0,9.58-1V15.49h-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M424.77,1.61c-1.88-.07-4.44-.15-6.13-.15-8.57,0-10.74,4.41-10.74,14.6,0,9.65,2,14.56,10.74,14.56,1.58,0,5.23,0,7.64-.09l-1.51-4h-5.38c-5.64,0-6.68-2.72-6.68-10.47,0-8,1.29-10.52,6.56-10.52h5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M713.15,1.61c-1.88-.07-4.44-.15-6.13-.15-8.57,0-10.74,4.41-10.74,14.6,0,9.65,2,14.56,10.74,14.56,1.58,0,5.23,0,7.64-.09l-1.51-4h-5.38c-5.64,0-6.68-2.72-6.68-10.47,0-8,1.29-10.52,6.56-10.52h5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.85,21.34V1.86h-4.69V21.25c0,6.9,3.68,9.7,10.49,9.7s10.58-2.8,10.58-9.7V1.86h-4.68V21.34c0,3.84-2.05,5.56-5.9,5.56s-5.8-1.68-5.8-5.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M456,21.34V1.86h-4.68V21.25c0,6.9,3.68,9.7,10.49,9.7s10.57-2.8,10.57-9.7V1.86h-4.68V21.34c0,3.84-2.05,5.56-5.89,5.56S456,25.22,456,21.34"
  }))), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "304.88 30.48 309.52 30.48 309.52 5.9 310.11 5.9 321.43 30.48 329.38 30.48 329.38 1.84 324.74 1.84 324.74 26.38 324.11 26.38 312.99 1.84 304.88 1.84 304.88 30.48"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "516.52 30.45 521.16 30.45 521.16 5.87 521.74 5.87 533.07 30.45 541.01 30.45 541.01 1.81 536.37 1.81 536.37 26.35 535.74 26.35 524.63 1.81 516.52 1.81 516.52 30.45"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "242.31 30.48 246.95 30.48 246.95 6.98 247.57 6.98 254.35 24.03 259.19 24.03 265.97 6.98 266.59 6.98 266.59 30.48 271.27 30.48 271.27 1.84 263.17 1.84 256.77 18.93 250.38 1.84 242.31 1.84 242.31 30.48"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "676.65 1.86 670.93 26.51 668.83 26.51 663.12 1.86 658.25 1.86 665.31 30.63 674.46 30.63 681.52 1.86 676.65 1.86"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0,23.53l1.24-1L0,21.85v1.68ZM15.3,0,1.24,11l8.49,4.85,5.57-4.39Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.05,19.51l1.23.71V18.53ZM17,0V11.48l5.62,3.2L31.05,8Z"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "0 23.53 15.3 32.21 15.3 20.73 0 12 0 23.53"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "16.98 20.82 16.98 32.28 32.28 20.21 32.28 8.68 16.98 20.82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmsLogoOneline);
export default __webpack_public_path__ + "static/media/kms_logo_oneline.10620e1001e4b298db7caf3c1a95d639.svg";
export { ForwardRef as ReactComponent };